import { Link } from 'react-router-dom';
import { videoPlatforms } from '@/mocks/site';

export default function PlatformSection() {
  return (
    <section className="py-14 md:py-16 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            精选视频平台
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            聚合多平台优质资源，你想看的这里都有
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {videoPlatforms.map((platform) => (
            <Link
              key={platform.slug}
              to={`/category/${platform.slug}`}
              className="group relative p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 overflow-hidden"
            >
              <div className={`absolute inset-0 bg-gradient-to-br ${platform.gradient} opacity-0 group-hover:opacity-5 transition-opacity duration-300`}></div>
              <div className="relative z-10">
                <div className={`w-11 h-11 flex items-center justify-center rounded-xl bg-gradient-to-br ${platform.gradient} mb-4`}>
                  <i className={`${platform.icon} text-background-50 text-lg`}></i>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1 whitespace-nowrap">
                  {platform.name}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {platform.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}